export default "__VITE_ASSET__MFHyoCOd__"